import {createEntityService} from 'utils/createEntityService';

export const DashboardService = createEntityService<any>({
  baseUrl: 'api/v1/dashboard',
  entityName: 'dashboard',
});
